angular.module('app').controller('PreviewCommunicationCtrl', function($mdDialog, $rootScope, $http, appUtils, $sce) {
    "ngInject";

    var main = this;
    main.event_signup = false;
    main.contact = false;

    main.done = function() {
        $mdDialog.hide();
    }

    main.subjectSearch = function(searchText) {
        return appUtils.orSearch(
            'event_signup',
            ['first_name', 'last_name'],
            searchText,
            {
                'q': {
                    'filters': [
                        {
                            'name': 'event_id',
                            'op': 'eq',
                            'val': main.item.event_id
                        }
                    ]
                }
            }
        );
    }

    main.buildPreview = function() {
        var data = main.buildData();
        data.preview = true;

        main.loading = $http({'method': 'POST', 'url': '/api/v1/admin/communication', 'data': data});
        main.loading.then((response) => {
            main.preview_html = $sce.trustAsHtml(response.data.html);
            main.preview_sms = response.data.sms;
            main.preview_subject = response.data.subject;
        })
    }

    if(main.item.event_id) {
        main.subjectSearch('').then((results) => {
            if(results) {
                main.event_signup = results[0];
            }
        });
    }

    main.buildData = function() {
        var data = angular.copy(main.item);
        data.recipient_group = 'Send to Individuals';
        var first_name = 'Jane';
        var last_name = 'Doe';
        var cell = '';
        if(main.event_signup) {
            if(main.event_signup.contacts.length > 0) {
                first_name = main.event_signup.contacts[0].first_name;
                last_name = main.event_signup.contacts[0].last_name;
            } else if(main.event_signup.subject.user_subjects.length > 0) {
                first_name = main.event_signup.subject.user_subjects[0].user.first_name;
                last_name = main.event_signup.subject.user_subjects[0].user.last_name;
            }
        }

        if(main.contact) {
            first_name = main.contact.first_name;
            last_name = main.contact.last_name;
        }
        if(main.item.send_sms) {
            cell = main.cell_phone;
        }
        data.intended_recipients = [{'email': main.email, 'first_name': first_name, 'last_name': last_name, 'cell_phone': cell}];
        if(!data.event_signup_id) {
            data.event_signup_id = main.event_signup.id;
        }
        return data;
    }

    main.sendTest = function() {
        var data = main.buildData();
        data.test = true;

        main.loading = $http({'method': 'POST', 'url': '/api/v1/admin/communication', 'data': data});
        main.loading.then(function() {
            appUtils.toast('Test sent');
        })
    }

    main.email = $rootScope.email;

    if(main.item.recipient_group == 'School Contact' && main.item.event) {
        $http({'method': 'GET', 'url': `/api/v1/admin/school/${main.item.event.school.id}`}).then((results) => {
            main.contacts = results.data.contacts;
            main.contact = main.contacts[0];
        });
    } else if (main.type == 'individual') {
        main.contacts = main.item.intended_recipients;
        main.contact = main.item.intended_recipients[0];
        main.buildPreview();
    }

})
